module.exports = __webpack_public_path__ + "static/media/favicon.5c774430.png";